import { Box, Modal, Tooltip } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import styled from "styled-components";
import { FEATURES } from "../../../../constants/features";
import { useIfUserEligible } from "../../../../hooks/useIfUserEligible";
import { usePaletteColor } from "../../../../hooks/usePaletteColor";
import { getWheelColorPalette } from "../../../../redux/selectors/segmentBuilderSelectors";
import { colors as Colors } from "../../../../utils";
import Button from "../../../Button";
import FeatureEligibility from "../../../FeatureEligibility";
import TextView from "../../../TextView";
import ColorPaletteModal from "../../Shared/ColorPalette/ColorPaletteModal";
import { buildSwatchTooltip } from "./swatchTooltip";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;
const GridContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
`;

const CircleBorder = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px;
  border-radius: 50%;
  border: 1px solid ${Colors.lightGrey};
`;
const Circle = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
`;

export default function WheelPaletteTab({
  handleSelectColor,
  selectedColor,
  showButtonAndTitle = false,
}) {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const selectedPalette = useSelector(getWheelColorPalette) || {};
  const { getPaletteColor } = usePaletteColor();

  const colors = selectedPalette.colors ? [...selectedPalette?.colors] : [];

  const {
    isEligible,
    subscription,
    isCheckingEligibility,
    requiredSubscription,
  } = useIfUserEligible(FEATURES.ADV_PALLETE_GENERATOR);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  if (isCheckingEligibility) {
    return (
      <Wrapper>
        {/* {showButtonAndTitle && (
          <TextView variant="subtitle">Wheel Palette</TextView>
        )} */}
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight={200}
        >
          <CircularProgress size={40} />
        </Box>
      </Wrapper>
    );
  }

  if (!isEligible) {
    return (
      <Wrapper>
        {/* {showButtonAndTitle && (
          <TextView variant="subtitle">Wheel Palette</TextView>
        )} */}
        <FeatureEligibility
          subscription={"Essential"}
          requiredSubscription={1}
        />
      </Wrapper>
    );
  }

  return (
    <Wrapper>
      {/* {showButtonAndTitle && (
        <TextView variant="subtitle">Wheel Palette</TextView>
      )} */}

      <div
        style={{
          marginTop: 5,
          backgroundColor: Colors.lightBorder,
          padding: 8,
          borderRadius: 4,
        }}
      >
        <TextView>
          *Changing the Palette will automatically update all Blocks using those
          colors!
        </TextView>
      </div>

      {!!colors.length ? (
        <>
          <TextView variant="largeText">
            {selectedPalette.paletteName || selectedPalette.palette_name}
          </TextView>
          <GridContainer>
            {colors.map((color, index) => {
              const isSelected = getPaletteColor(selectedColor) == color.hex;
              return (
                <CircleBorder
                  style={{
                    borderColor: isSelected ? Colors.lightGrey : "transparent",
                  }}
                  key={index}
                >
                  <Tooltip
                    placement="top"
                    title={
                      <span style={{ whiteSpace: "pre-line" }}>
                        {buildSwatchTooltip(
                          color.hex,
                          typeof handleSelectColor === "function"
                        )}
                      </span>
                    }
                  >
                    <Circle
                      style={{ backgroundColor: color.hex }}
                      onClick={() =>
                        handleSelectColor && handleSelectColor(index)
                      }
                    />
                  </Tooltip>
                </CircleBorder>
              );
            })}
          </GridContainer>
        </>
      ) : (
        <>
          <TextView variant="largeText">Default Theme</TextView>
          <TextView>
            Segment colors are chosen from a pre-defined library of basic colors.
          </TextView>
        </>
      )}

      {showButtonAndTitle && (
        <>
          <Button onClick={handleOpenModal}>Open Palette Generator</Button>

          {isModalVisible && (
            <Modal open={isModalVisible} onClose={handleCloseModal}>
              <ColorPaletteModal
                onClose={handleCloseModal}
                paletteType="wheel"
              />
            </Modal>
          )}
        </>
      )}
    </Wrapper>
  );
}
